import { useQuery } from "@apollo/client"
import { GET_PATIENT_CASES } from "../../graphql/queries"
import { Flex, Text, Card, Heading, Box } from 'rebass/styled-components'
import { IGetPatientCasesInput, IGetPatientCasesOutput, IPatientCase } from "../../graphql/types/queries/patientCases"
import styled from "styled-components";
import { Route, NavLink as NavLinkRouter, Outlet, useParams, useNavigate } from "react-router-dom";
import Modal from "styled-react-modal";
import { SpecialModalBackground } from "../../components/Commons";
import { useState } from "react";
import { PatientCaseWithParams } from "./PatientCase";
import { VerticalTimeline, VerticalTimelineElement } from "react-vertical-timeline-component";
import { parseStringify } from "../../utils/StringUtils";
import PleaseWait from "../../components/PleaseWait";

const ListContainer = styled(Flex)`
min-width: min(300px, 100vw);
  /* border-right: 1px solid #ccc; */
  /* width: 100%; */
  /* min-width: 200px; */
  padding-right: 12px;
  overflow-y: auto;
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: #6c89b7;
    border-radius: 5px;
  }
  &::-webkit-scrollbar {
    width: 7px;
    border: 1px solid transparent;
  }
  /* border-right: 1px solid #355078; */
  &.selected {
    display: none;
  }

  @media screen and (min-width: 68.8125em) {
    width: auto;
    &.selected {
      display: flex;
    }
  }
`;

const Wrapper = styled(Flex)`
  overflow: auto;
  width: 800px;
  padding-right: 20px;
  margin-right: 20px;
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: #6c89b7;
    border-radius: 5px;
  }
  &::-webkit-scrollbar {
    width: 7px;
    border: 1px solid transparent;
  }
`;

const NavLink = styled(NavLinkRouter)`
  text-decoration: none;
  color: #355078;
  display: flex;
  align-items: center;
  /* border-bottom: 1px solid #355078; */
  width: 90%;
  flex: 1;
  /* min-height: 100px; */
  transition: all 300ms ease;
  &.active {
    /* background: rgba(180, 205, 244, 0.5); */
    color: white;
  }
  &:hover {
    /* background: rgba(180, 205, 244, 0.5); */
  }
`;


const Inner = styled(Flex)`
  /* max-width: 650px; */
`;

const DetailContainer = styled(Flex)`
  display: none;
  overflow-y: auto;
  /* padding-bottom: 64px; */
  &.selected {
    display: flex;
  }

  @media screen and (min-width: 68.8125em) {
    display: flex;
  }
`;

const ListItem = styled(Flex)`
  /* border-bottom: 1px solid #ccc; */
`;

const CardWrap = styled(Card)`
  width: 100%;
  max-width: 95%;
  flex: initial;
  margin-bottom: 16px;
  padding: 12px 16px;
  margin-left: 12px;
  cursor: pointer;
  &.active {
    background: rgba(109,126,154, 0.5);
    /* color: white; */
  }
  &.isInModal {
    max-width: 100% !important;
  }
  @media screen and (min-width: 68.8125em) {
  max-width: 250px;
  }

  /* @media screen and (max-width: 480px) {
    flex-direction: column-reverse;
  } */
`;
const contentStyleSelected = {
  background: 'rgb(53, 80, 120)',
  boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.05)',
  borderRadius: '10px',
  padding: '12px 0px',
}
const contentStyle = {
  background: '#F0F5FD',
  boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.05)',
  borderRadius: '10px',
  padding: '12px 0px',
}
const contentStyleMinimizedSelected = {
  background: 'rgb(53, 80, 120)',
  boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.05)',
  borderRadius: '10px',
  padding: '12px 0px',
  marginBottom: '12px'
}
const contentStyleMinimized = {
  background: '#F0F5FD',
  boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.05)',
  borderRadius: '10px',
  padding: '12px 0px',
  marginBottom: '12px'
}

const contentArrowStyleSelected = {
  borderRight: '7px solid rgb(53, 80, 120)',
}

const contentArrowStyle = {
  borderRight: '7px solid  #F0F5FD',
}

const iconStyle = {
  width: '20px',
  height: '20px',
  background: '#FFFFFF',
  border: '3px solid #BCFFEB',
  margin: '10px',
  boxShadow: 'initial'
}

interface PatientCasesProps {
  patientId: string,
  isMinimized?: boolean
}

export const PatientCases: React.FC<PatientCasesProps> = ({ patientId, isMinimized }) => {
  let params = useParams<{
    id: string,
    caseId: string
  }>()
  const navigate = useNavigate()
  const [selectedCase, setSelectedCase] = useState<string>()
  const { data, loading } = useQuery<IGetPatientCasesOutput, IGetPatientCasesInput>(GET_PATIENT_CASES, {
    variables: {
      patientId
    },
    onCompleted: e => {
      if (!!isMinimized) return

      if (e && e.providerGetPatientCases && e.providerGetPatientCases.length > 0) {
        navigate(`/patient/${patientId}/patientCase/${e.providerGetPatientCases[e.providerGetPatientCases.length - 1].patientCaseId}`)
      }
    }
  })

  if (!!loading) {
    return <PleaseWait />
  }

  if (!data || !data.providerGetPatientCases || data.providerGetPatientCases.length < 1) {
    return (
      <Flex width='100%' height={'100%'} justifyContent={'center'} alignItems={'center'}>
        <Heading textAlign={'center'}>No patient's case</Heading>
      </Flex>
    )
  }

  return (
    <Flex width='100%' overflowY={'hidden'}>
      <ListContainer className={!!params.caseId ? 'selected' : ''} width={isMinimized ? '100% !important' : ''} flexDirection={isMinimized ? 'column' : 'row'}>
        <Flex flexDirection={'column'} id='lstWrap' width={isMinimized ? '95% !important' : '100%'}>
          <VerticalTimeline layout='1-column' lineColor='#344F7A' >
            {(parseStringify(data?.providerGetPatientCases) as IPatientCase[])?.reverse().map(x => {
              return (
                <VerticalTimelineElement
                  className="vertical-timeline-element--work"
                  contentStyle={!isMinimized ? params.caseId === x.patientCaseId ? contentStyleSelected : contentStyle : params.caseId === x.patientCaseId ? contentStyleMinimizedSelected : contentStyleMinimized}
                  contentArrowStyle={params.caseId === x.patientCaseId ? contentArrowStyleSelected : contentArrowStyle}
                  style={{
                    margin: 0,
                    marginBottom: '12px',
                    width: '100%'
                  }}
                  iconStyle={iconStyle} key={x.patientCaseId}
                >
                  {!isMinimized ? (
                    <NavLink to={`/patient/${patientId}/patientCase/${x.patientCaseId}`}>
                      <Flex paddingX={'12px'} alignItems={'center'}>
                        {x.hcFilledFormId && (
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                            style={{ marginRight: '12px' }}>
                            <path d="M7 17H9.1L15.1 11.05L12.95 8.9L7 14.85V17ZM15.8 10.35L17.2 8.9L15.1 6.8L13.65 8.2L15.8 10.35ZM3 21V3H9.2C9.41667 2.4 9.77933 1.91667 10.288 1.55C10.7967 1.18333 11.3673 1 12 1C12.6333 1 13.2043 1.18333 13.713 1.55C14.2217 1.91667 14.584 2.4 14.8 3H21V21H3ZM12 4.25C12.2167 4.25 12.3957 4.179 12.537 4.037C12.6783 3.895 12.7493 3.716 12.75 3.5C12.75 3.28333 12.679 3.10433 12.537 2.963C12.395 2.82167 12.216 2.75067 12 2.75C11.7833 2.75 11.6043 2.821 11.463 2.963C11.3217 3.105 11.2507 3.284 11.25 3.5C11.25 3.71667 11.321 3.89567 11.463 4.037C11.605 4.17833 11.784 4.24933 12 4.25Z"
                              fill={params.caseId === x.patientCaseId ? 'white' : "rgb(53, 80, 120)"} />
                          </svg>
                        )}

                        <Flex flexDirection={'column'}>
                          <Text fontWeight={500}>{x.subject}</Text>

                          <Flex>
                            <Text fontWeight={300} mr={2} fontSize={'12px'}>{`${x.lastModifiedDate}, `}</Text>
                            <Text fontWeight={300} fontSize={'12px'}>{`${(x.documentSource || '').toLowerCase()}`}</Text>
                          </Flex>
                        </Flex>
                      </Flex>
                    </NavLink>
                  ) : (<Flex flexDirection={'column'} onClick={() => setSelectedCase(x.patientCaseId)}>
                    <Text fontWeight={500}>{x.subject}</Text>

                    <Flex>
                      <Text fontWeight={300} mr={2} fontSize={'12px'}>{`${x.lastModifiedDate}, `}</Text>
                      <Text fontWeight={300} fontSize={'12px'}>{`${(x.documentSource || '').toLowerCase()}`}</Text>
                    </Flex>
                  </Flex>)}
                </VerticalTimelineElement>)
            })}
          </VerticalTimeline>
        </Flex>
      </ListContainer>
      {isMinimized && selectedCase ? (

        <Modal
          isOpen={true}
          onBackgroundClick={() => {
            setSelectedCase(undefined);
          }}
          onEscapeKeydown={() => {
            setSelectedCase(undefined);
          }}
        >
          <SpecialModalBackground
            onClick={() => {
              setSelectedCase(undefined);
            }}
          >
            <Box
              style={{
                margin: '0 auto',
                alignSelf: 'center',
                borderRadius: '20px',
                position: 'relative',
                background: 'linear-gradient(180deg, #BBD4ED 0%, #FDF5F2 100%)',
                padding: '24px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                maxWidth: '95vw',
                minWidth: 'initial',
                maxHeight: '95vh',
                minHeight: '95vh',
                overflowY: 'hidden',
              }}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
              }}
            >
              <Wrapper flex={1} flexDirection={'column'} width={'800px'} style={{ overflowY: 'auto' }}>
                <PatientCaseWithParams id={patientId} caseId={selectedCase} isInModal={true} />
              </Wrapper>
            </Box>
          </SpecialModalBackground>
        </Modal>
      ) : (
        <DetailContainer flex={1} width='100%' justifyContent="flex-start" paddingX={4} className={!!params.caseId ? 'selected' : ''} id="testContainer">
          <Inner flex={1} flexDirection="column" pt={[0, 0, 0]} overflowY={'hidden'} >
            <Outlet />
          </Inner>
        </DetailContainer>
      )}
    </Flex>
  )
}